export default {
    message: {
        "availability": "Verfügbarkeit",
        "shipping_preparation": "Geschätzte Lieferzeit",
        "days": "Tage",
        "quantity": "Quantität",
        "add_to_cart": "In den Einkaufswagen",
        "quantity_no_available": "Die angeforderte Menge ist derzeit nicht verfügbar",
        "product_no_available": "Produkt kommt bald",
        "choose": "Wählen",
        "Loading": "Wird geladen ...",

    },
}
